import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/product-mapping")
export class AdminViewProductMappingBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.productMapping;
}
